module.exports = __webpack_public_path__ + "img/christmas-island.4bc5248b.png";